import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import Auth from "./views/Auth";

export const publicRoute = [
  {
    path: "/",
    extact: true,
    layout: DefaultLayout,
    component: Auth
  }
];

const privateRoute = [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/medias" />
  },
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview
  },
  {
    path: "/user",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  //라우터 경로 / 2개 쓰면 안된다. 
  {
    path: "/write",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/inquiry",
    layout: DefaultLayout,
    component: Tables
  },

  {
    path: "/medias",
    layout: DefaultLayout,
    component: BlogPosts
  }
];
export default privateRoute;
